import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import DeviceDetail from './pages/DeviceDetail';
import DeviceForm from './pages/DeviceForm';
import Requests from './pages/Requests';
import RequestForm from './pages/RequestForm';
import RequestDetail from './pages/RequestDetail';
import ResolvedRequests from './pages/ResolvedRequests';
import ReplacementAlgorithm from './pages/ReplacementAlgorithm';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Settings from './pages/Settings';
import Licenses from './pages/Licenses';
import Maintenances from './pages/Maintenances';
import CaniasRequests from './pages/CaniasRequests';
import ChatPage from './pages/ChatPage';
import OnlineUsers from './pages/OnlineUsers';
import MimDeskPage from './pages/MimDeskPage';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/devices" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><Devices /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/devices/new" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><DeviceForm /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/devices/:id" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><DeviceDetail /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/devices/:id/edit" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><DeviceForm /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/requests" element={
            <ProtectedRoute>
              <Layout><Requests /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/requests/new" element={
            <ProtectedRoute>
              <Layout><RequestForm /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/requests/:id" element={
            <ProtectedRoute>
              <Layout><RequestDetail /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/resolved-requests" element={
            <ProtectedRoute roles={['admin', 'it', 'user']}>
              <Layout><ResolvedRequests /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/canias-requests" element={
            <ProtectedRoute roles={['admin', 'it', 'user']}>
              <Layout><CaniasRequests /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/replacement-algorithm" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><ReplacementAlgorithm /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/licenses" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><Licenses /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/maintenances" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><Maintenances /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/users" element={
            <ProtectedRoute roles={['admin']}>
              <Layout><Users /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/users/:id" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><UserDetail /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/settings" element={
            <ProtectedRoute roles={['admin']}>
              <Layout><Settings /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/chat" element={
            <ProtectedRoute>
              <Layout><ChatPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/online-users" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><OnlineUsers /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/mimdesk" element={
            <ProtectedRoute roles={['admin', 'it']}>
              <Layout><MimDeskPage /></Layout>
            </ProtectedRoute>
          } />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
